import { VisitorInfo } from '../../types/VisitorInfo.type'

export const fetchVisitorInfoData = async (): Promise<VisitorInfo> => {
  return fetch(`/relevanceapi/visitorinfo`, {
    credentials: 'include'
  })
    .then(response => {
      return response.json()
    })
    .catch(() => {
      console.error('failed to fetch visitor info data')
    })
}
